module.exports = __webpack_public_path__ + "static/media/beesProductNice.451d393b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/beesProductNice.jpg
// module id = 243
// module chunks = 0